import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Timer } from '@landtrustinc/design-system';
import { EarlyAccessButton } from '..';
import css from './EarlyAccessButtonWithTimer.module.css';

const EarlyAccessButtonWithTimer = ({ expirationTimestamp, setIsModalOpen }) => {
  return (
    <div className={css.earlyAccess}>
      <EarlyAccessButton setIsModalOpen={setIsModalOpen} />

      <div className={css.packageAvailableTimer}>
        <FormattedMessage id="PackagePage.packageAvailable" />
        &nbsp;
        <Timer expirationTimestamp={expirationTimestamp} showSeconds fontSize="12px" />
      </div>
    </div>
  );
};

export default EarlyAccessButtonWithTimer;
